export const LIVE_PLATFORMS = {
  live_youtube: {
    platform: 'youtube',
    label: 'YouTube Live',
    icon: '/images/youtubeIcon.png',
    placeholder: 'https://www.youtube.com/watch?v=... or /@channel',
  },
  live_twitch: {
    platform: 'twitch',
    label: 'Twitch Live',
    icon: '/images/twitch_app.png',
    placeholder: 'https://www.twitch.tv/channelname',
  },
  live_vimeo: {
    platform: 'vimeo',
    label: 'Vimeo Live',
    icon: '/images/vimeoIcon.png',
    placeholder: 'https://vimeo.com/event/123456',
  },
};

const TWITCH_QUALITY_PARAM = {
  '1080p': '1080p60',
  '720p': '720p60',
  '480p': '480p',
  '360p': '360p',
};

const YT_QUALITY_PARAM = {
  '1080p': 'hd1080',
  '720p': 'hd720',
  '480p': 'large',
  '360p': 'medium',
};

export const buildLiveEmbedUrl = (widget) => {
  if (!widget) return null;
  const mute = widget.mute ? '1' : '0';
  const quality = widget.quality && widget.quality !== 'auto' ? widget.quality : null;

  switch (widget.widgetCat) {
    case 'live_youtube': {
      const params = new URLSearchParams({ autoplay: '1', mute, playsinline: '1' });
      if (quality) params.set('vq', YT_QUALITY_PARAM[quality]);
      if (widget.videoId) {
        return `https://www.youtube.com/embed/${widget.videoId}?${params.toString()}`;
      }
      if (widget.channelId) {
        params.set('channel', widget.channelId);
        return `https://www.youtube.com/embed/live_stream?${params.toString()}`;
      }
      return null;
    }
    case 'live_twitch': {
      if (!widget.channelId) return null;
      const params = new URLSearchParams({
        channel: widget.channelId,
        parent: window.location.hostname,
        autoplay: 'true',
        muted: widget.mute ? 'true' : 'false',
      });
      if (quality) params.set('quality', TWITCH_QUALITY_PARAM[quality]);
      return `https://player.twitch.tv/?${params.toString()}`;
    }
    case 'live_vimeo': {
      const params = new URLSearchParams({ autoplay: '1', muted: mute });
      if (quality) params.set('quality', quality);
      if (widget.eventId) {
        return `https://player.vimeo.com/event/${widget.eventId}/embed?${params.toString()}`;
      }
      if (widget.videoId) {
        return `https://player.vimeo.com/video/${widget.videoId}?${params.toString()}`;
      }
      return null;
    }
    default:
      return null;
  }
};
